import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getAuthUserId } from "@/utils/authUser";
import ChatRoomList from "@/components/chat/ChatRoomList";

/**
 * Business messages — the same live room list the students see, scoped to the
 * signed-in business account.
 */
const BusinessMessagesPage: React.FC = () => {
  const { t } = useTranslation();
  const currentUserId = useSelector((state: any) => getAuthUserId(state.auth));

  return (
    <ChatRoomList
      currentUserId={currentUserId}
      basePath="/portal/chat"
      title={t("Messages")}
      emptyMessage={t(
        "Start a chat from a student reviewing your coupon or sponsor task.",
      )}
    />
  );
};

export default BusinessMessagesPage;
